import { Component, Input } from "@angular/core";
import { PrimaryCarePhysician } from "@core/model";
import { Observable } from "rxjs";

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-primary-care-physician-history',
    templateUrl: './primary-care-physician-history.component.html',
    styleUrls: ['./primary-care-physician-history.component.scss'],
    standalone: false
})

export class PrimaryCarePhysicianHistoryComponent {
  @Input() primaryCarePhysicianHistory$: Observable<PrimaryCarePhysician[]>;
}
